"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DistributionLists = exports.DistributionListRow = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var text_1 = require("utils/text");
var components_1 = require("components");
require("./style.scss");
var enhance = (0, recompose_1.compose)((0, recompose_1.withState)('maxWidth', 'setMaxWidth', 0), (0, recompose_1.lifecycle)({
    componentWillMount: function () {
        var maxwidth = this.props.wizard.values.distributionLists.reduce(function (p, r) {
            var len = (0, text_1.calculateStringLength)(r.name) + 60;
            if (p > len)
                return p;
            return len;
        }, 0);
        this.props.setMaxWidth(maxwidth);
    }
}), recompose_1.pure);
var DistributionListRow = function (props) {
    return (React.createElement(sok_ui_1.Table.Row, { className: 'distribution-lists-row' },
        React.createElement(sok_ui_1.Table.Column, null,
            React.createElement(components_1.TableRowIcon, { icon: 'fa-clipboard-list' })),
        React.createElement(sok_ui_1.Table.Column, null,
            React.createElement(components_1.TableRowIcon, { icon: 'fa-times-circle', onClick: props.removeDistributionList(props.list), disabled: props.disabled })),
        React.createElement(sok_ui_1.Table.Column, { style: { width: props.width } },
            React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, props.list.name) },
                React.createElement("span", null, props.list.name))),
        React.createElement(sok_ui_1.Table.Column, null,
            React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, props.list.description) },
                React.createElement("span", null, props.list.description)))));
};
exports.DistributionListRow = DistributionListRow;
exports.DistributionLists = enhance(function (props) { return (React.createElement("div", { className: 'distribution-and-order-distribution-lists' },
    React.createElement(sok_ui_1.Table.Table, { className: 'striped distribution-lists' },
        React.createElement(sok_ui_1.Table.Head, null,
            React.createElement(sok_ui_1.Table.Row, null,
                React.createElement(sok_ui_1.Table.Column, null),
                React.createElement(sok_ui_1.Table.Column, null),
                React.createElement(sok_ui_1.Table.Column, null, (0, translation_1.getLocalization)('userfront/order/distribution/name')),
                React.createElement(sok_ui_1.Table.Column, null, (0, translation_1.getLocalization)('userfront/order/distribution/description')))),
        React.createElement(sok_ui_1.Table.Body, null, props.wizard.values.distributionLists
            .sort(function (a, b) { return a.name.localeCompare(b.name); })
            .reduce(function (result, row) {
            result.push(React.createElement(exports.DistributionListRow, __assign({ key: "".concat(row.id, "-header"), list: row, width: props.maxWidth }, props, { disabled: props.disabled })));
            return result;
        }, []))))); });
exports.default = exports.DistributionLists;
